module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	"use strict";

	fox.registerWidget('UserOfferModelRelated_List', {
		offerAlias:'',

		configure: function (options) {
			this.registerOptions('', {
				autoRender: true,
				template: 'relatedModelsOffer',
				'embed.container': '#related-models-offer',
				containerOffers: '#list-items',
				widgets: {
					modelsDl: {
						widget: 'Datalayer',
						method: 'Offer_ModelRelated.list'
					},
					list: {
						widget: 'Grid_List',
						container: '#list-items',
						tpl: {
							row: 'relatedModelsOffer_item',
							emptyRow: 'relatedModelsOffer_item_empty'
						},
						externalLoad: true,
						dataLayer: '@parent #modelsDl',
						'hooks.onAddedToDom': fox.bind(this.createGalleries, this)
					}
				},
				handleWom: {
					modelRelatedUpdated: {
						widget: fox.UserOffer,
						event: 'modelRelatedUpdated',
						params: {
							listenHistory: true
						},
						callback: fox.bind(this.updateList, this)
					},
					purchaseEventDone: {
						widget: fox.UserOffer,
						event: 'purchaseEventDone',
						params: {
							listenHistory: true
						},
						callback: fox.bind(function() {
							this.waitPurchaseEvent = false;
							var but = this.dom('#list-items .btn-join.spin');
							fox.dom.removeClass('spin', but);
						}, this)
					},
					modelsDlLoaded: {
						widget: '#modelsDl',
						event: 'loaded',
						callback: 'setMinDiscount'
					}
				},
				handleDom: {
					purchase: {
						targetWidget: '#list',
						target: '.btn-join',
						event: 'click',
						eventChecker: fox.bind(function (event) {
							return !fox.dom.hasClass('disabled', event.currentTarget) && !this.waitPurchaseEvent;
						}, this),
						callback: fox.bind(this.purchaseEvent, this)
					},
					imgErrorLoad: {
						targetWidget: '#list',
						event: 'error',
						target: '.avatar',
						callback: function(elem) {
							$(elem).remove();
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		// when subscription renewed and you move to other page and back to account, offer should be blocked
		activate: function() {
			this.wait('addedToDom').then(function() {
				this.renderMinDiscount();
			}.bind(this));
			
			this.callParent('activate', arguments);
		},

		deactivate: function () {
			if (this.container.hasClass('slick-initialized')) {
				this.container.slick('unslick');
			}

			this.callParent('deactivate', arguments);
		},

		running: function () {
			this.callParent('running', arguments);
			this.list = this.wom1('#list');
			this.dl = this.rwom1('#modelsDl');
		},

		updateList: function (data) {
			this.dl.setTransitParameter('offerAlias', data);
			this.dl.load();
		},

		purchaseEvent: function (el) {
			fox.UserOffer.checkAction('purchaseOffer', {clientId: el.getAttribute('data-id')});
			this.waitPurchaseEvent = true;
			fox.dom.addClass('spin', el);
		},

		createGalleries: function() {
			this.container = $(this.element).find(this.getOption('containerOffers'));
			var containerAlias = this.getOption('embed.container');

			var initSlick = function() {
				this.container.slick({
					infinite: false,
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
					centerPadding:0,
					dots: false,
					prevArrow: containerAlias + ' .arrow-prev',
					nextArrow: containerAlias + ' .arrow-next',
					responsive: [
						{
							breakpoint: 960,
							settings: {
								slidesToShow: 3
							}
						},
						{
							breakpoint: 860,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 640,
							settings: {
								slidesToShow: 1
							}
						}
					]
				});

				this.container.slick('setPosition', 0);
			};

			if (this.container.hasClass('slick-initialized') && /* fix double addedToDom issue */
				!this.container.find('.slick-list').length) {
				this.container.removeClass('slick-initialized slick-slider');
			}

			initSlick.call(this);
		},

		renderMinDiscount: function() {
			this.dom1('#discount').innerHTML = (this.minDiscount || '20') + '%';
		},

		setMinDiscount: function(obj, dl) {
			this.minDiscount = dl.getMetaValue('minDiscount');
			this.renderMinDiscount();

		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/offer/controllers/UserOfferModelRelated/list.js
// module id = 130
// module chunks = 4